import React, { useEffect, useRef } from "react";

export function StreamVideo({ stream, muted = false, mirror = false, className = "", testId }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (el.srcObject !== stream) el.srcObject = stream || null;
    if (stream) el.play?.().catch(() => {});
  }, [stream]);
  return (
    <video ref={ref} autoPlay playsInline muted={muted} data-testid={testId}
      className={`${className} ${mirror ? "-scale-x-100" : ""}`} />
  );
}
